export default {
    path: '/docs',
    component: () => import('@/views/docs/Documentation.vue'),
    children: [
        { path: ':docId', component: () => import('@/views/docs/Documentation.vue') },
    ]
};
